import { AuthService } from '@service/auth';
import { useCallback } from 'react';

import type { MeResponse } from '../types';
import { useMeResponse } from './useMeResponse';

type MeQueryResponse = {
  res: MeResponse;
};

export function useMeQuery() {
  const { setMeFromResponse } = useMeResponse();
  const { doMeQuery, meLoading } = AuthService.meQuery();

  const me = useCallback(async (): Promise<MeQueryResponse> => {
    const me = await doMeQuery();

    setMeFromResponse(me);

    return {
      res: me,
    };
  }, [doMeQuery, setMeFromResponse]);

  return { me, meLoading };
}
